import { Component, DoCheck, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Exception } from '@zxing/library';
import { MASKS } from 'ng-brazil';
import { Auth } from 'src/app/models/auth';
import { GroupProduct, GroupProductUpdate, GroupRascunho, GroupUpdate, ProdutoRascunho } from 'src/app/models/group';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { GroupService } from 'src/app/services/group/group.service';
import { ProductsGroupService } from 'src/app/services/group/products-group.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { CategoriaProduto } from 'src/app/shared/enums/categoria-produto.enum';

@Component({
  selector: 'app-grupo-regras',
  templateUrl: './grupo-regras.component.html',
  styleUrls: ['./grupo-regras.component.css']
})
export class GrupoRegrasComponent implements OnInit, DoCheck {

  public currentUser: Auth;
  public rascunho: GroupRascunho;
  public products: GroupProduct[] = [];

  public MASKS = MASKS;

  public valorFlex = '';
  public valorDiferenca = 0;

  public temFlexivel = false;
  public flexivel: ProdutoRascunho;

  public groupGuid: any;
  public messageMaxValue = "O valor mínimo deve ser menor ou igual ao valor máximo do produto";

  constructor(private router: Router,
    private authenticationService: AuthenticationService, private groupService: GroupService,
    private productsGroupService: ProductsGroupService, private alertService: NewAlertService) { }

  ngDoCheck() {
    let soma = 0;

    this.rascunho.products.forEach(item => {
      soma += +item.value ;
    });

    if (+this.valorFlex <= soma) {
      this.valorDiferenca = 0;
    } else {
      this.valorDiferenca = +this.valorFlex - soma;
    }
  }

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;
    this.rascunho = this.groupService.getRascunho();
    let soma = 0;
    if (this.rascunho.products.length === 0) {
      this.router.navigate(['portal/grupos/beneficios']);
    } else {
      this.rascunho.products.forEach(item => {
        if (!item.standardPeriodCard || item.standardPeriodCard == 3) {
          item.standardPeriodCard = 1;
        }

        if (item.produtoCategoria === CategoriaProduto.Flex) {
          this.temFlexivel = true;
          this.flexivel = item;
          if(parseFloat(item.value) > 0)
            this.valorFlex = item.value;
        }
        soma += +item.value;
      });
      if(!this.rascunho.isEdicao)
        this.valorFlex = "0";
      this.rascunho.products = this.rascunho.products.filter(x => x.produtoCategoria !== 2);
    }
  }

  next() {
    this.groupService.setRascunho(this.rascunho);
    this.router.navigate(['portal/grupos/resumo']);
  }

  finish() {
    let soma = 0;

    this.rascunho.products.forEach(item => {
        soma += +item.value;
        item.value  = (item.value).toString();
        /*if(parseFloat(item.value) > item.maxValue && item.produtoCategoria != 2){
            this.alertService.error(this.messageMaxValue);
            throw true;
        }*/
    });

    // if (this.getValue(this.valorFlex) < soma && this.temFlexivel) {
    //   this.alertService.error('O valor dos incentivos não pode exceder o valor total!');
    //   return;
    // } else
    if (this.temFlexivel) {
      const flex = new ProdutoRascunho(this.flexivel.produtoId, this.flexivel.produtoGuid, this.flexivel.standardPeriodCard, (this.valorFlex).toString(),this.flexivel.maxValue, '', '', this.flexivel.produtoNome,this.flexivel.produtoDescImportante, this.flexivel.produtoCategoria);
      this.rascunho.products.push(flex);
    }

    const groupUpdate = new GroupUpdate(this.rascunho.name, this.rascunho.description,
    this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId);

    this.rascunho.products.forEach(item => {
        this.products.push(new GroupProduct(item.produtoId, item.standardPeriodCard, +item.value));
    });

    if (this.rascunho.isEdicao) {
      this.updateGroup(groupUpdate);
    } else {
      this.addGroup(groupUpdate);
    }
  }

  updateGroup(groupUpdate: GroupUpdate) {
    this.groupService.updateGroup(groupUpdate, this.rascunho.guid).subscribe(
      res => {

        if (res.status === ApiError.Sucesso) {

          this.groupGuid = this.rascunho.guid;
          const productUpdate = new GroupProductUpdate(this.products, this.rascunho.guid, this.currentUser.token.userReferenceId);
          this.productsGroupService.updateProducts(productUpdate).subscribe(
            res2 => {
              if (res2.status === ApiError.Sucesso) {
                this.groupService.setRascunho(null);
                this.getGroup();
              } else {
                this.alertService.error(res2.message);
              }
            },
            error2 => {
              this.alertService.error('Erro ao vincular os incentivos!');
            }
          );
        }
      },
      error => {
        this.alertService.error('Erro ao editar o grupo!');
      }
    );
  }

  addGroup(groupUpdate: GroupUpdate) {
    this.groupService.addGroup(groupUpdate).subscribe(
      res => {

        if (res.status === ApiError.Sucesso) {
            this.groupGuid = res.result.guidID;
            const productUpdate = new GroupProductUpdate(this.products, res.result.guidID, this.currentUser.token.userReferenceId);

            this.productsGroupService.addProducts(productUpdate).subscribe(
                res2 => {
                this.groupService.setRascunho(null);
                this.getGroup();
                },
                error2 => {
                this.alertService.error('Erro ao vincular os incentivos!');
                }
            );
        }
      },
      error => {
        this.alertService.error('Erro ao cadastrar o grupo!');
      }
    );
  }

  setPeriodo(periodo: number, item: ProdutoRascunho) {
    item.standardPeriodCard = periodo;
  }

  getValue(stringValue: string) {
    return +(stringValue.replace('R$', '').replace(/\./g, '').replace(',', '.').trim());
  }

  getGroup(){
    this.groupService.getGroupById(this.currentUser.token.assignorGuid, this.groupGuid).subscribe(response => {
        if (response.status === 1) {
            sessionStorage.setItem('Grupo', JSON.stringify(response.result));
            this.router.navigate(['portal/grupos/detalhe']);
        }
    });
  }

}
